import React from "react";
import './ServiceSection.scss';

const processSteps = [
    {
        id: 1,
        title: "Observer et comprendre",
        description: "Découverte du chien et de son univers pour cerner ses besoins et ses comportements.",
        icon: "🐕"
    },
    {
        id: 2,
        title: "Accompagner et guider",
        description: "Mise en place d'un accompagnement personnalisé pour appliquer des solutions concrètes et progresser ensemble pas à pas.",
        icon: "👥"
    },
    {
        id: 3,
        title: "Renforcer la complicité",
        description: "Création d'une relation harmonieuse et durable, basée sur la confiance et la communication, main dans patte.",
        icon: "✨"
    }
];

const ServiceSection = (props) => {
    return (
        <section className={"process-section " + props.hclass}>
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-lg-8 col-12">
                        <div className="section-title text-center">
                            <h3>Mon approche</h3>
                            <h2>Un processus de suivi en 3 étapes pour des résultats garantis</h2>
                        </div>
                    </div>
                </div>
                <div className="row">
                    {processSteps.map((step, index) => (
                        <div className="col-lg-4 col-md-12 col-12" key={step.id}>
                            <div className="process-item">
                                <div className="process-number">{step.id}</div>
                                <div className="process-icon">
                                    <span className="icon-emoji">{step.icon}</span>
                                </div>
                                <div className="process-content">
                                    <h3>{step.title}</h3>
                                    <p>{step.description}</p>
                                </div>
                            </div>
                            {index < processSteps.length - 1 && (
                                <div className="process-arrow d-none d-lg-block">
                                    <i className="fi flaticon-next"></i>
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}

export default ServiceSection;

